import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Phone, Mail, MapPin, Send } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we'll be in touch soon.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch { toast.error("Failed to send"); }
    setBusy(false);
  };

  return (
    <div data-testid="contact-page">
      <Navbar/>
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto">
        <div className="absolute inset-0 -z-10 overflow-hidden">
          <img src="/images/dashboard.jpg" alt="" className="w-full h-full object-cover opacity-10"/>
        </div>
        <p className="eyebrow mb-3">Contact</p>
        <h1 className="font-serif text-5xl md:text-7xl mb-2">Get in <span className="italic gradient-gold">touch.</span></h1>
        <div className="divider"/>

        <div className="grid md:grid-cols-2 gap-16 mt-12">
          <div className="space-y-8">
            <a href="tel:9544514424" className="flex items-start gap-5 group">
              <div className="w-12 h-12 rounded-full border border-[#5DCFE5] flex items-center justify-center group-hover:bg-[#5DCFE5] transition">
                <Phone size={18} className="text-[#5DCFE5] group-hover:text-[#050a12]"/>
              </div>
              <div>
                <p className="eyebrow mb-1">Call</p>
                <p className="font-serif text-2xl">954-451-4424</p>
              </div>
            </a>
            <a href="mailto:1motionelitetransport@gmail.com" className="flex items-start gap-5 group">
              <div className="w-12 h-12 rounded-full border border-[#5DCFE5] flex items-center justify-center group-hover:bg-[#5DCFE5] transition">
                <Mail size={18} className="text-[#5DCFE5] group-hover:text-[#050a12]"/>
              </div>
              <div>
                <p className="eyebrow mb-1">Email</p>
                <p className="font-serif text-xl">1motionelitetransport@gmail.com</p>
              </div>
            </a>
            <div className="flex items-start gap-5">
              <div className="w-12 h-12 rounded-full border border-[#5DCFE5] flex items-center justify-center">
                <MapPin size={18} className="text-[#5DCFE5]"/>
              </div>
              <div>
                <p className="eyebrow mb-1">Service Area</p>
                <p className="font-serif text-xl">Miami · Fort Lauderdale · Palm Beach · South Florida</p>
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="card-dark p-8 space-y-4">
            <input data-testid="contact-name" required placeholder="Full Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="input-dark"/>
            <input data-testid="contact-email" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="input-dark"/>
            <input data-testid="contact-phone" placeholder="Phone (optional)" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} className="input-dark"/>
            <textarea data-testid="contact-message" required rows={5} placeholder="How can we help?" value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="input-dark"/>
            <button data-testid="contact-submit" disabled={busy} className="btn-gold w-full justify-center">{busy ? "Sending..." : <>Send Message <Send size={14}/></>}</button>
          </form>
        </div>
      </section>
      <Footer/>
    </div>
  );
}
